module.exports = __webpack_public_path__ + "img/27-SEND.f4d1209c.jpg";